// extracted by mini-css-extract-plugin
export default {"Box":"column-frame-module__Box--zhwyJ","Box_1":"column-frame-module__Box_1--xdN2G"};